import { Box, Container, List, ListItem, Typography } from '@mui/material';

export function PrivacyPolicyArabic({ sx, ...other }) {
  return (
    <Box
      component="section"
      sx={[
        {
          pb: 10,
          pt: { xs: 3, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Box>
          <Box display="flex" justifyContent="around">
            <Box>
              <Box>
                <Box sx={{ m: 5 }}>
                  <Typography
                    component="h5"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '24px',
                      margin: '10px 40px 0px 0px',
                      textAlign: 'center',
                    }}
                  >
                    سياسة الخصوصية
                  </Typography>
                  {/* <!--------------- Introduction And Information Collection Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>مقدمة</Typography>
                  <Typography>
                    منصة شحن، المملوكة لشركة فكر للاتصالات وتقنية المعلومات، ملتزمة بحماية خصوصيتك
                    وضمان أمان معلوماتك الشخصية. توضح هذه السياسة كيف نجمع ونستخدم ونحمي معلوماتك
                    عند استخدام خدماتنا، سواء عبر تطبيق الهاتف المحمول أو موقعنا الإلكتروني.
                    باستخدامك لمنصة شحن، فإنك توافق على الشروط الموضحة في هذه السياسة.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>سياسة الخصوصية</Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>1.جمع المعلومات</Typography>
                  <Typography sx={{ fontWeight: 'bold', mr: 4 }}>
                    {' '}
                    1.1 أنواع المعلومات التي يتم جمعها
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, mr: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          المعلومات الشخصية:
                        </Typography>{' '}
                        تتضمن اسمك، عنوانك، رقم هاتفك، عنوان بريدك الإلكتروني، وأي معلومات أخرى يمكن
                        أن تحدد هويتك كفرد.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          المعلومات غير الشخصية:
                        </Typography>{' '}
                        تتضمن البيانات التي لا تحدد هويتك مباشرةً، مثل نوع جهازك، عنوان IP، نوع
                        المتصفح، بيانات الاستخدام، وسجل التصفح.
                      </Typography>
                    </ListItem>
                  </List>

                  <Typography sx={{ fontWeight: 'bold', mr: 4 }}> 1.2 طرق جمع المعلومات</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, mr: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تسجيل الحساب :
                        </Typography>{' '}
                        عند إنشاء حساب، نجمع المعلومات الشخصية لإعداد ملفك الشخصي وتقديم خدماتنا.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          بيانات الاستخدام:
                        </Typography>{' '}
                        نجمع معلومات حول تفاعلاتك مع منصتنا، مثل الصفحات التي تزورها، الميزات التي
                        تستخدمها، وتاريخ المعاملات.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          المصادر الخارجية:
                        </Typography>{' '}
                        قد نحصل على معلومات من شركائنا ومقدمي الخدمات لتعزيز خدماتنا.
                      </Typography>
                    </ListItem>
                  </List>

                  {/* <!--------------- Use of Information Related Policies --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>2. استخدام المعلومات </Typography>
                  <Typography sx={{ fontWeight: 'bold', mr: 4 }}> 2.1 تحسين الخدمة</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, mr: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          تعزيز تجربة المستخدم :
                        </Typography>{' '}
                        نستخدم بياناتك لتخصيص وتحسين وظائف منصتنا، مما يضمن تجربة مستخدم أفضل.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          التواصل :
                        </Typography>{' '}
                        تساعدنا معلوماتك في التواصل معك بشأن حسابك، معاملاتك، وتحديثات خدماتنا.
                      </Typography>
                    </ListItem>
                  </List>

                  <Typography sx={{ fontWeight: 'bold', mr: 4 }}>
                    {' '}
                    2.2 الأمان والامتثال القانوني
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, mr: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          حماية البيانات :
                        </Typography>{' '}
                        نستخدم معلوماتك لحماية حسابك والمنصة من الأنشطة الاحتيالية.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          المتطلبات القانونية :
                        </Typography>{' '}
                        قد نفصح عن معلوماتك للامتثال للالتزامات القانونية أو الرد على الطلبات
                        القانونية من السلطات الحكومية.
                      </Typography>
                    </ListItem>
                  </List>

                  <Typography sx={{ fontWeight: 'bold', mr: 4 }}> 2.3 التسويق والتحليل</Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, mr: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          العروض الترويجية :
                        </Typography>{' '}
                        قد نستخدم بياناتك لإرسال المحتوى الترويجي والعروض الخاصة، بناءً على موافقتك.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          التحليل :
                        </Typography>{' '}
                        نحلل بيانات الاستخدام لفهم سلوك المستخدم وتفضيلاته، مما يساعدنا في تحسين
                        خدماتنا.
                      </Typography>
                    </ListItem>
                  </List>

                  {/* <!--------------- Cookies and Tracking Technologies Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    3. ملفات تعريف الارتباط وتقنيات التتبع{' '}
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', mr: 4 }}>
                    3.1 أنواع ملفات تعريف الارتباط المستخدمة
                  </Typography>
                  <List sx={{ listStyleType: 'disc', pl: 4, mr: 4 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          ملفات تعريف الارتباط الأساسية :
                        </Typography>{' '}
                        ضرورية لوظائف الموقع الأساسية، مثل التنقل في المناطق الآمنة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          ملفات تعريف الارتباط للأداء :
                        </Typography>{' '}
                        تجمع معلومات حول كيفية استخدام الزوار للموقع للمساعدة في تحسين أدائه.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          ملفات تعريف الارتباط الوظيفية :
                        </Typography>{' '}
                        تتذكر تفضيلاتك لتوفير ميزات محسنة ومخصصة.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                      <Typography>
                        {' '}
                        <Typography component="span" sx={{ fontWeight: 'bold' }}>
                          ملفات تعريف الارتباط للإعلان :
                        </Typography>{' '}
                        تقدم إعلانات ذات صلة بك وتقيس فعاليتها.
                      </Typography>
                    </ListItem>
                  </List>

                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.2 إدارة ملفات تعريف الارتباط :
                    </Typography>{' '}
                    يمكنك إدارة ملفات تعريف الارتباط أو حذفها عبر إعدادات المتصفح الخاص بك. قد يؤثر
                    تعطيل ملفات تعريف الارتباط على وظائف منصتنا.
                  </Typography>

                  {/* <!--------------- Information Sharing and Disclosure  Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    4. مشاركة المعلومات والإفصاح عنها{' '}
                  </Typography>

                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.1 مقدمو الخدمات الخارجية :
                    </Typography>{' '}
                    نشارك بياناتك مع أطراف ثالثة موثوقة تساعدنا في تشغيل منصتنا، مثل معالجي الدفع،
                    شركاء التسويق، ومقدمي خدمات تكنولوجيا المعلومات.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.2 الإفشاء والتصريح :
                    </Typography>{' '}
                    قد نشارك معلوماتك مع جهات خارجية لتحسين خدماتنا، مثل تخصيص التطبيق وإجراء
                    التحليلات السلوكية.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.3 الإفصاحات القانونية :
                    </Typography>{' '}
                    قد نفصح عن معلوماتك استجابةً للطلبات القانونية أو لحماية حقوقنا وممتلكاتنا
                    وسلامتنا، وكذلك سلامة مستخدمينا والجمهور.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.4 التتبع في الخلفية :
                    </Typography>{' '}
                    نتتبع مواقع السائقين والشحنات لتحسين التسليم ولأغراض داخلية فقط.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.5 جمع المعلومات :
                    </Typography>{' '}
                    نجمع معلومات الهوية مثل الاسم، رقم الهوية، تاريخ الميلاد، ومعلومات الاتصال مثل
                    رقم الهاتف والبريد الإلكتروني.
                    <br />
                    نجمع معلومات المركبات وتفاصيل أخرى ذات صلة لتحسين خدماتنا.
                  </Typography>

                  {/* <!--------------- Data Security  Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>5. أمان البيانات </Typography>

                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.1 تدابير الأمان :
                    </Typography>{' '}
                    ننفذ تدابير أمان متقدمة لحماية بياناتك من الوصول غير المصرح به أو التعديل أو
                    التدمير.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.2 الاحتفاظ بالبيانات :
                    </Typography>{' '}
                    نحتفظ ببياناتك فقط طالما كان ذلك ضروريًا لتحقيق الأغراض الموضحة في هذه السياسة
                    أو كما يقتضيه القانون.
                  </Typography>

                  {/* <!--------------- User Rights Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>6. حقوق المستخدم </Typography>

                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.1 الوصول والتصحيح :
                    </Typography>{' '}
                    لديك الحق في الوصول إلى المعلومات الشخصية التي نحتفظ بها عنك وطلب تصحيحها إذا
                    كانت غير دقيقة أو غير كاملة.{' '}
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.2 الحذف :
                    </Typography>{' '}
                    يمكنك طلب حذف معلوماتك الشخصية، ما لم يكن هناك سبب قانوني أو تشغيلي يمنعنا من
                    ذلك.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.3 نقل البيانات :
                    </Typography>{' '}
                    لديك الحق في طلب نقل بياناتك الشخصية إلى مزود خدمة آخر.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.4 الاعتراض والتقييد :
                    </Typography>{' '}
                    يمكنك الاعتراض على أو طلب تقييد معالجة بياناتك في ظروف معينة.
                  </Typography>

                  {/* <!--------------- Policy Updates Related Policies --------------------------> */}

                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      7. تحديثات السياسة :
                    </Typography>{' '}
                    قد نقوم بتحديث سياسة الخصوصية هذه لتعكس التغييرات في ممارساتنا أو المتطلبات
                    القانونية. سنقوم بإخطارك بأي تغييرات كبيرة عبر منصتنا أو بوسائل أخرى مناسبة.
                  </Typography>
                  <br />

                  {/* <!--------------- Terms and Conditions Related Policies --------------------------> */}

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>شروط وأحكام </Typography>

                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      1. قبول الشروط :
                    </Typography>{' '}
                    باستخدامك لمنصة شحن، فإنك توافق على الالتزام بهذه الشروط والأحكام، التي تشكل
                    اتفاقية قانونية ملزمة بينك وبين شحن.
                  </Typography>
                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      2. وصف الخدمة :
                    </Typography>{' '}
                    توفر شحن منصة إلكترونية تربط العملاء الذين يحتاجون إلى خدمات النقل بالناقلين
                    الذين يمتلكون الشاحنات المناسبة. تشمل الخدمات الإيجار اليومي والشهري وحلول
                    اللوجستيات الأخرى.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>3. مسؤوليات المستخدم </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.1 معلومات دقيقة :
                    </Typography>{' '}
                    يجب عليك تقديم معلومات دقيقة وكاملة عند إنشاء حسابك واستخدام خدماتنا. أي تضليل
                    قد يؤدي إلى تعليق أو إنهاء حسابك.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.2 الامتثال للقوانين :
                    </Typography>{' '}
                    توافق على الامتثال لجميع القوانين واللوائح المعمول بها أثناء استخدام منصتنا. أي
                    انتهاك قد يؤدي إلى تعليق أو إنهاء حسابك.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      3.3 الأنشطة المحظورة :
                    </Typography>{' '}
                    يجب عدم استخدام منصتنا لأي أغراض غير قانونية أو غير مصرح بها، بما في ذلك نقل
                    المواد المحظورة أو الانخراط في أنشطة احتيالية.
                  </Typography>
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>4. الرسوم والمدفوعات </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.1 رسوم الخدمة :
                    </Typography>{' '}
                    توافق على دفع جميع الرسوم المرتبطة باستخدام خدماتنا، كما هو موضح على منصتنا. قد
                    تشمل هذه الرسوم رسوم الإيجار، رسوم الساعات الإضافية، وغرامات التأخير.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      4.2 شروط الدفع :
                    </Typography>{' '}
                    يجب إجراء المدفوعات من خلال الطرق المحددة على منصتنا. قد يؤدي التأخير في الدفع
                    إلى تعليق أو إنهاء حسابك.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>
                    5. الحجوزات والإلغاءات{' '}
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.1 عملية الحجز :
                    </Typography>{' '}
                    يجب إجراء جميع الحجوزات عبر منصة شحن. ستتلقى تأكيدًا بمجرد قبول حجزك.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      5.2 سياسة الإلغاء :
                    </Typography>{' '}
                    تخضع الإلغاءات للشروط الموضحة في سياسات الخدمة الخاصة. قد تتكبد رسوم إلغاء بناءً
                    على توقيت وطبيعة الإلغاء.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>6. المسؤولية والتعويض </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.1 تحديد المسؤولية :
                    </Typography>{' '}
                    لا تتحمل شحن أي مسؤولية عن أي أضرار مباشرة أو غير مباشرة أو عرضية أو تبعية تنشأ
                    عن استخدامك للمنصة أو الخدمات المقدمة.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      6.2 التعويض :
                    </Typography>{' '}
                    توافق على تعويض وحماية شحن، وفروعها، ومسؤوليها، ومديريها، وموظفيها، ووكلائها من
                    أي مطالبات أو أضرار أو نفقات تنشأ عن استخدامك للمنصة أو انتهاكك لهذه الشروط.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>7. حل النزاعات </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      7.1 التفاوض :
                    </Typography>{' '}
                    في حالة نشوء نزاع، يجب على الأطراف أولاً محاولة حله من خلال التفاوض المباشر في
                    غضون خمسة عشر (15) يومًا.{' '}
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      7.2 التحكيم :
                    </Typography>{' '}
                    إذا لم يتم التوصل إلى حل من خلال التفاوض، سيتم تسوية النزاع عن طريق التحكيم
                    وفقًا لقواعد المركز السعودي للتحكيم التجاري. سيتم إجراء التحكيم في الرياض،
                    المملكة العربية السعودية، وستكون الإجراءات باللغة العربية.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>8. إنهاء </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      8.1 إنهاء من قبل شحن :
                    </Typography>{' '}
                    تحتفظ شحن بالحق في إنهاء حسابك في أي وقت لأي سبب، مع أو بدون إشعار.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      8.2 إنهاء من قبل المستخدم :
                    </Typography>{' '}
                    يمكنك إنهاء حسابك عن طريق حذف التطبيق والتوقف عن استخدام خدماتنا.
                  </Typography>

                  <Typography>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      9. الملكية الفكرية :
                    </Typography>{' '}
                    جميع المحتويات على منصة شحن، بما في ذلك النصوص والرسومات والشعارات والصور
                    والبرامج، هي ملك لشحن أو المرخصين لها ومحمية بموجب قوانين الملكية الفكرية. لا
                    يجوز لك استخدام أي من هذه المحتويات دون إذن كتابي صريح منا.
                  </Typography>

                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>10. أحكام عامة </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      10.1 الاتفاق الكامل :
                    </Typography>{' '}
                    تشكل هذه الشروط والأحكام الاتفاق الكامل بينك وبين شحن بشأن استخدام خدماتنا.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      10.2 القانون الواجب التطبيق :
                    </Typography>{' '}
                    يخضع هذا الاتفاق لقوانين المملكة العربية السعودية، ويتم حل أي نزاعات في المحاكم
                    السعودية.
                  </Typography>
                  <Typography sx={{ mr: 4 }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                      10.3 قابلية الفصل :
                    </Typography>{' '}
                    إذا تبين أن أي حكم من هذه الشروط والأحكام غير صالح أو غير قابل للتنفيذ، ستظل
                    الأحكام المتبقية سارية المفعول.
                  </Typography>
                  <br />
                  {/* <!--------------- Contact Us Division --------------------------> */}
                  <Typography sx={{ fontWeight: 'bold', my: 2 }}>الاتصال بنا </Typography>

                  <Typography>
                    إذا كان لديك أي أسئلة أو مخاوف بشأن سياسة الخصوصية وشروط وأحكام هذه، يرجى
                    الاتصال بنا على: <br />
                    البريد الإلكتروني: care@shahen-sa.com الهاتف: 0112299855
                  </Typography>
                  <br />
                  <Typography>
                    باستخدامك لمنصة شحن، فإنك تقر بأنك قد قرأت وفهمت وتوافق على الالتزام بسياسة
                    الخصوصية وشروط وأحكام هذه.
                  </Typography>
                  <br />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
